import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function YoutubeSearchedForIcon(props: IconProps) {
    return <Icon {...props} iconKey={"youtube_searched_for"}/>
}
